'use client'

import { ClickableElement } from 'constants/tracking/clickable-elements'
import { Screen } from 'constants/tracking/screens'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { clickEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

type LinkModel = { text: string; url: string; testId: string }

const linksItems1 = [
  {
    text: 'column_1.item_1',
    url: 'column_1.link_1',
    testId: 'link_item-helpcenter',
  },
]

const linksItems2 = [
  {
    text: 'column_2.item_1',
    url: 'column_2.link_1',
    testId: 'link_item-check_rules',
  },
]

const linksItems3 = [
  {
    text: 'column_3.item_1',
    url: 'column_3.link_1',
    testId: 'link_item-read_directive',
  },
]

const LinksSection = () => {
  const translate = useTranslate('dac7-2024.links')

  const { track } = useTracking()

  const handleOnLinkClick = (url: string) => {
    track(
      clickEvent({
        screen: Screen.Dac7,
        target: ClickableElement.Hyperlink,
        targetDetails: `links_section__${url}`,
      }),
    )
  }

  const renderLinks = (linksItems: Array<LinkModel>) =>
    linksItems.map(({ url, text, testId }) => {
      const linkUrl = translate(url)

      return (
        <li key={text}>
          <a
            className="dac7__links-item"
            href={linkUrl}
            onClick={() => handleOnLinkClick(linkUrl)}
            data-testid={testId}
          >
            {translate(text)}
          </a>
        </li>
      )
    })

  const renderLinksGroup = (heading: string, linksItems: Array<LinkModel>) => (
    <div className="dac7__links-group">
      <h3 className="dac7__links-group-heading">{translate(heading)}</h3>
      <ul>{renderLinks(linksItems)}</ul>
    </div>
  )

  return (
    <section className="dac7__links" data-testid="links_container">
      <h2 className="dac7__links-title">{translate('title')}</h2>
      <div className="dac7__links-wrapper">
        {renderLinksGroup('column_1.title', linksItems1)}
        {renderLinksGroup('column_2.title', linksItems2)}
        {renderLinksGroup('column_3.title', linksItems3)}
      </div>
    </section>
  )
}

export default LinksSection
